export default function returnFileSize(number: number) {
  return Number((number / 1048576).toFixed(1));
}
